import { render, staticRenderFns } from "./RirsTable.vue?vue&type=template&id=5af5b46e&scoped=true"
import script from "./RirsTable.vue?vue&type=script&lang=js"
export * from "./RirsTable.vue?vue&type=script&lang=js"
import style0 from "./RirsTable.vue?vue&type=style&index=0&id=5af5b46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5b46e",
  null
  
)

export default component.exports